import {
    GET_TICKETS,
    GET_TICKETS_SUCCESS,
    GET_TICKETS_FAIL,
    GET_TICKET_DETAIL,
    GET_TICKET_DETAIL_SUCCESS,
    GET_TICKET_DETAIL_FAIL,
    CREATE_SUPPORT_TICKET,
    CREATE_SUPPORT_TICKET_SUCCESS,
    CREATE_SUPPORT_TICKET_FAIL,
    REPLY_SUPPORT_TICKET,
    REPLY_SUPPORT_TICKET_SUCCESS,
    REPLY_SUPPORT_TICKET_FAIL,
} from "./actionTypes"

export const getTickets = (params) => ({
    type: GET_TICKETS,
    payload: params,
})

export const getTicketsSuccess = (tickets) => ({
    type: GET_TICKETS_SUCCESS,
    payload: tickets,
})

export const getTicketsFail = (error) => ({
    type: GET_TICKETS_FAIL,
    payload: error,
})

export const getTicketDetail = (id) => ({
    type: GET_TICKET_DETAIL,
    payload: id,
})

export const getTicketDetailSuccess = (ticket) => ({
    type: GET_TICKET_DETAIL_SUCCESS,
    payload: ticket,
})

export const getTicketDetailFail = (error) => ({
    type: GET_TICKET_DETAIL_FAIL,
    payload: error,
})

export const createSupportTicket = (ticket, navigate) => ({
    type: CREATE_SUPPORT_TICKET,
    payload: { ticket, navigate },
})

export const createSupportTicketSuccess = (ticket) => ({
    type: CREATE_SUPPORT_TICKET_SUCCESS,
    payload: ticket,
})

export const createSupportTicketFail = (error) => ({
    type: CREATE_SUPPORT_TICKET_FAIL,
    payload: error,
})

export const replySupportTicketAction = (id, message) => ({
    type: REPLY_SUPPORT_TICKET,
    payload: { id, message },
})

export const replySupportTicketSuccess = (reply) => ({
    type: REPLY_SUPPORT_TICKET_SUCCESS,
    payload: reply,
})

export const replySupportTicketFail = (error) => ({
    type: REPLY_SUPPORT_TICKET_FAIL,
    payload: error,
})
